import {FormGroup} from '@angular/forms';
import {NeqAbstractViewComponent} from './abstract-view.component';
import {AfterViewInit, Component} from '@angular/core';

@Component({
  template: ''
})
export abstract class NeqAbstractFormViewComponent extends NeqAbstractViewComponent implements AfterViewInit {

  ngAfterViewInit() {
    // fix IE11, input is marked dirty when placeholder was defined.
    setTimeout(() => {
      const form = this.getFormGroup();
      if (form) {
        for (const key in form.controls) {
          if (form.controls[key]) {
            form.controls[key].markAsPristine();
          }
        }
      }
    }, 500);
  }

  abstract getFormGroup(): FormGroup;

}


